import { Box, Typography } from "@mui/material";
import React from "react";
import Orangelogo from "../../assets/images/Orangelogo.png";

const OurTeam = () => {
  return (
    <Box
      sx={{
        maxWidth: { xs: "100%", sm: "1440px" },
        margin: "0 auto",

        marginTop: "2rem",
        display: "flex",
        flexDirection: { xs: "column", sm: "column" },
        padding: { xs: "0rem 1.8rem", sm: "0rem 3rem" },
        backgroundColor: "#ecebeb",
      }}
    >
      <Box
        sx={{
          width: { xs: "100%", sm: "50%" },
        }}
      >
        <Box
          sx={{
            width: "4rem",
            marginTop: { xs: "4rem", sm: "2rem" },
          }}
        >
          <img src={Orangelogo} alt="" width="100%" />
        </Box>
        <Typography
          sx={{
            fontFamily: "Montserrat",
            fontSize: { xs: "0.8rem", sm: "1rem" },
            marginTop: "0.5rem",
            fontWeight: "400",
            textTransform: "uppercase",
          }}
        >
          WHAT OUR TEAM IS LIKE
        </Typography>
        <Typography
          variant="h4"
          sx={{
            fontFamily: "Montserrat",
            fontSize: { xs: "1.4rem", sm: "1.6rem" },
            fontWeight: "500",
            marginTop: "0.8rem",
          }}
        >
          The{" "}
          <span style={{ color: "rgba(255, 102, 0, 1)" }}>
            Inteliphyle Tribe
          </span>
        </Typography>
      </Box>

      <Box
        sx={{
          width: "100%",
        }}
      ></Box>
    </Box>
  );
};

export default OurTeam;
